import { Box, Button, Typography, useTheme } from '@material-ui/core'
import useStyles from './styles'
import { PUMP_PARTS_STORE_PAGE_URL } from '../../constants'

const InvalidPartsOrderView = () => {
  const theme = useTheme()
  const classes = useStyles()

  return (
    <Box
      bgcolor={theme.palette.background.contrast}
      px={{ xs: 4, sm: 0 }}
      py={8}
    >
      <Box className={classes.container}>
        <Typography
          className={classes.title}
          color="primary"
          component="h1"
          variant="h4"
        >
          We're sorry!
        </Typography>
        <Typography className={classes.body} color="primary" variant="body2">
          The insurance plan you purchased your pump with is no longer active.
        </Typography>
        <Typography className={classes.body} color="primary" variant="body2">
          At this time, we do not support updating your insurance information to
          place replacement pump part orders, but we hope to in the near future.
        </Typography>

        <Typography
          className={classes.subtitle}
          color="primary"
          component="h1"
          variant="h4"
        >
          Need parts now?
        </Typography>
        <Typography className={classes.body} color="primary" variant="body2">
          We should have what you need on the Babylist Shop.
        </Typography>

        <Button
          classes={{ root: classes.linkButton }}
          color="secondary"
          href={PUMP_PARTS_STORE_PAGE_URL}
          size="large"
          variant="contained"
        >
          Shop for Pump Parts
        </Button>
      </Box>
    </Box>
  )
}

export default InvalidPartsOrderView
